import { gql } from '@apollo/client/core'

export const RESOURCE_TAG_FRAGMENT = gql`
  fragment ResourceTag on ResourceTag {
    id
    label
    slug
    position
  }
`
